import Vue from 'vue'
import { formatDistanceStrict } from 'date-fns'

Vue.filter('formatTime', value => {

    if (!value) return 'None'

    return formatDistanceStrict(parseInt(value) * 60000, 0)

})